// extracted by mini-css-extract-plugin
export var banner = "_1w-0";
export var icon = "_1w-1";
export var message = "_1w-2";